import { createActions } from 'redux-actions';

export const { bootstrapPage } = createActions({
  bootstrapPage: () => undefined,
},
{ prefix: 'COMMISSION' }
);
